import React from 'react';
import { DIMENSIONES, valoresDeDimension, coincideDimension } from '../utils/agrupar';

// Muestra los productos de una categoría agrupados por talla o marca (tarjetas).
// Si la categoría tiene ambas dimensiones, ofrece un toggle "Por talla / Por marca".
export default function GruposGrid({
  categoria, productos, dimension, dimensiones,
  onCambiarDimension, onSeleccionar, onTodas, onVolver, onVerCategorias,
}) {
  const delaCategoria = productos.filter((p) => p.categoria === categoria);
  const { valores, haySin } = valoresDeDimension(delaCategoria, dimension);
  const contar = (valor) => delaCategoria.filter((p) => coincideDimension(p, dimension, valor)).length;
  const info = DIMENSIONES[dimension];

  const Tarjeta = ({ etiqueta, cantidad, onClick, destacada }) => (
    <div onClick={onClick}
      style={{ backgroundColor: destacada ? '#FDF2F8' : 'white', border: `2px solid ${destacada ? 'var(--color-primario,#DB2777)' : '#F3F4F6'}`, borderRadius: '14px', padding: '20px 16px', textAlign: 'center', cursor: 'pointer', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
      <div style={{ fontSize: '28px', marginBottom: '6px' }}>{info.icono}</div>
      <p style={{ margin: '0 0 2px', fontSize: '15px', fontWeight: 'bold', color: '#111827' }}>{etiqueta}</p>
      <p style={{ margin: 0, fontSize: '12px', color: '#9CA3AF' }}>{cantidad} producto{cantidad === 1 ? '' : 's'}</p>
    </div>
  );

  return (
    <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '8px' }}>
        <h2 style={{ color: '#374151', margin: 0 }}>{info.icono} {categoria} — por {info.etiqueta.toLowerCase()}</h2>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={onVerCategorias} style={{ background: 'none', border: '1px solid #D1D5DB', borderRadius: '8px', padding: '6px 12px', cursor: 'pointer', color: '#6B7280' }}>🗂️ Categorías</button>
          <button onClick={onVolver} style={{ background: 'none', border: '1px solid #D1D5DB', borderRadius: '8px', padding: '6px 12px', cursor: 'pointer', color: '#6B7280' }}>← Volver</button>
        </div>
      </div>

      {/* Toggle Talla / Marca cuando la categoría tiene ambas */}
      {dimensiones.length > 1 && (
        <div style={{ display: 'inline-flex', gap: '4px', backgroundColor: '#F3F4F6', borderRadius: '10px', padding: '4px', marginBottom: '16px' }}>
          {dimensiones.map((d) => (
            <button key={d} onClick={() => onCambiarDimension(d)}
              style={{ padding: '6px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold', backgroundColor: dimension === d ? 'var(--color-primario,#DB2777)' : 'transparent', color: dimension === d ? 'white' : '#6B7280' }}>
              {DIMENSIONES[d].icono} Por {DIMENSIONES[d].etiqueta.toLowerCase()}
            </button>
          ))}
        </div>
      )}

      <p style={{ margin: '0 0 16px', fontSize: '13px', color: '#9CA3AF' }}>
        Toca una {info.etiqueta.toLowerCase()} para ver solo esos productos.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: '14px' }}>
        <Tarjeta etiqueta="Ver todas" cantidad={delaCategoria.length} onClick={onTodas} destacada />
        {valores.map((v) => (
          <Tarjeta key={v} etiqueta={`${info.prefijoTarjeta}${v}`} cantidad={contar(v)} onClick={() => onSeleccionar(v)} />
        ))}
        {haySin && (
          <Tarjeta etiqueta={info.sinLabel} cantidad={contar('__sin__')} onClick={() => onSeleccionar('__sin__')} />
        )}
      </div>
    </div>
  );
}
